import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none",
  viewBox: "0 0 48 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#24A1DE",
      d: "M31.6 3.2H16.4c-6.6 0-9.9 0-11.95 2.05S2.4 10.6 2.4 17.2v15.2c0 6.6 0 9.9 2.05 11.95S9.8 46.4 16.4 46.4h15.2c6.6 0 9.9 0 11.95-2.05S45.6 39 45.6 32.4V17.2c0-6.6 0-9.9-2.05-11.95S38.2 3.2 31.6 3.2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12.178 24.572q9.446-4.115 12.596-5.426c5.999-2.495 7.245-2.929 8.057-2.943.18-.003.579.043.838.251.218.177.278.417.307.585q.066.423.036.85c-.325 3.416-1.731 11.706-2.447 15.53-.303 1.618-.9 2.16-1.476 2.214-1.253.116-2.207-.829-3.422-1.625-1.901-1.246-2.975-2.022-4.82-3.238-2.133-1.405-.75-2.178.465-3.44.318-.33 5.845-5.357 5.951-5.814.014-.057.026-.27-.1-.381-.127-.113-.312-.074-.447-.044q-.286.064-9.111 6.022-1.294.888-2.343.864c-.771-.017-2.254-.436-3.357-.794-1.353-.44-2.428-.673-2.333-1.42q.072-.581 1.606-1.192",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }